import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { getDayClass } from '../calendarCore/utils/getDayClass';
import DayIndicator from '../calendarCore/DayIndicator';
export default function DayCell({ day, disablePast, testId, onClick }) {
    const isChoosable = !day.alert && (!day.isInThePast || !disablePast) && !day.isBeforeMinDate && !day.isAfterMaxDate;
    const handleClick = () => {
        if (isChoosable)
            onClick();
    };
    return (_jsxs("button", { className: classNames('text-body flex h-9 shrink-0 flex-col items-center border pt-1.5 text-center text-xs leading-4', getDayClass(day), {
            'text-fg-disabled cursor-not-allowed opacity-40': !isChoosable,
            'cursor-pointer font-semibold': isChoosable,
        }), onClick: handleClick, "data-testid": testId.append('name'), children: [day.date.getDate(), _jsx(DayIndicator, { day: day, testId: testId })] }));
}
